import { useState } from "react";
import { ColorPicker, useColor } from "react-color-palette";
import "react-color-palette/css";
import fontSize from "../utils/fontSize";
import fontFamily from "../utils/fontFamily";
import UIPreview from "../child_components/UIPreview";
import axios from "axios";
import { url } from "../utils/config";
import { toast } from "react-toastify";
import Button from "../reusable_components/Button";
import { btnOne, inputStyle, subTitle, title } from "../utils/style";
import { useRecoilState } from "recoil";
import uiConfigAtom from "../atoms/uiConfigAtom";

function Customize() {
    const [ fontData, setFontData ] = useState({})
    const [ buttonData, setButtonData ] = useState({})
    const [ logoData, setLogoData ] = useState({})
    const [ logoUrl, setLogoUrl ] = useState();
    const [ iconData, setIconData ] = useState({})
    const [ iconUrl, setIconUrl ] = useState({})
    const [ primaryColor, setPrimaryColor] = useColor("rgb(86 30 203)");
    const [ secondaryColor, setSecondaryColor ] = useColor("rgb(86 30 110)");
    const [ btnBgColor, setBtnBgColor ] = useColor("rgb(86 30 203)")
    const [ btnFontColor, setBtnFontColor ] = useColor("rgb(86 30 203)")
    const [ headerColor, setHeaderColor ] = useColor("rgb(86 30 20)")
    const [ tableFontColour, setTableFontColor ] = useColor("rgb(181 195 181)")
    const [ showLoader, setShowLoader ] = useState(false)
    const [ propType, setPropType ] = useState('colour')
    const [ uiConfig ] = useRecoilState(uiConfigAtom)


    function updateFormData(e, state, setState) {
        const { name, value } = e.target;
        const data = {...state};
        data[name] = value;
        console.log(data)
        setState(data);
    }

    function updateLogoData(e) {
        const { name } = e.target;
        const file = e.target.files[0];
        const data = {...logoData};
        const url = {...logoUrl}
        data[name] = file;
        url[name] = URL.createObjectURL(file)
        setLogoData(data);
        setLogoUrl(url)
    }

    function updateIconData(e) {
        const { name } = e.target;
        const file = e.target.files[0];
        const data = {...iconData};
        const url = {...iconUrl}
        data[name] = file;
        url[name] = URL.createObjectURL(file)
        setIconData(data);
        setIconUrl(url)
    }

    function cancelImage(name, type) {
        if(type === 'logo') {
            var url = {...logoUrl};
            var data = {...logoData};
            delete url[name];
            delete data[name];
            setLogoUrl(url);
            setLogoData(data)
        } else {
            var url = {...iconUrl};
            var data = {...iconData};
            delete url[name];
            delete data[name];
            setIconUrl(url);
            setIconData(data)
        }
    }

    async function saveConfig() {
        try {
            setShowLoader(true)
            const formData = new FormData();
            formData.append('data', JSON.stringify({
                fontData, 
                button: {...buttonData, btnBgColor, btnFontColor},
                primaryColor, 
                secondaryColor, 
                table: {headerColor, fontColor: tableFontColour}
            }))
            for (const logo in logoData) {
                formData.append(logo, logoData[logo])
            }
            for (const icon in iconData) {
                formData.append(icon, iconData[icon])
            }

            const { data } = await axios.post(url + '/ui_config', formData);
            console.log(data)
            toast.success(data.message, { autoClose: 3000 })
            setShowLoader(false)
        } catch (error) {
            console.log(error)
            setShowLoader(false);
            toast.error(error.response.data.message, { autoClose: 3000 })
        }
    }


    return(
        <div>
            <div className="flex justify-between">
                <div className={title}>Customize UI</div>
                <div className='flex justify-end mb-2'>
                    <Button className={btnOne} name={'Save'} clickHandler={() => saveConfig()} />
                </div>
            </div>
            <div className='flex gap-8 py-6 border-b border-customThree'>
                <button 
                    className={`text-sm rounded-full py-2 px-8 border border-customOne ${propType === 'colour' ? `bg-customOne text-white` : `text-customOne`}`} 
                    style={propType === 'colour' ? {backgroundColor: uiConfig?.button?.btnBgColor?.hex, borderColor: uiConfig?.button?.btnBgColor?.hex} : {color: uiConfig?.button?.btnBgColor?.hex, borderColor: uiConfig?.button?.btnBgColor?.hex}}
                    onClick={() => setPropType('colour')}>Colour</button>
                    
                <button 
                    className={`text-sm rounded-full py-2 px-8 border border-customOne ${propType === 'font' ? 'bg-customOne text-white ' : 'text-customOne'}`}  
                    style={propType === 'font' ? {backgroundColor: uiConfig?.button?.btnBgColor?.hex, borderColor: uiConfig?.button?.btnBgColor?.hex} : {color: uiConfig?.button?.btnBgColor?.hex, borderColor: uiConfig?.button?.btnBgColor?.hex}}
                    onClick={() => setPropType('font')}>Font</button>
                <button 
                    className={`text-sm rounded-full py-2 px-8 border border-customOne ${propType === 'logo' ? 'bg-customOne text-white ' : 'text-customOne'}`}  
                    style={propType === 'logo' ? {backgroundColor: uiConfig?.button?.btnBgColor?.hex, borderColor: uiConfig?.button?.btnBgColor?.hex} : {color: uiConfig?.button?.btnBgColor?.hex, borderColor: uiConfig?.button?.btnBgColor?.hex}}
                    onClick={() => setPropType('logo')}>Logo</button>
                <button 
                    className={`text-sm rounded-full py-2 px-8 border border-customOne ${propType === 'button' ? 'bg-customOne text-white ' : 'text-customOne'}`}  
                    style={propType === 'button' ? {backgroundColor: uiConfig?.button?.btnBgColor?.hex, borderColor: uiConfig?.button?.btnBgColor?.hex} : {color: uiConfig?.button?.btnBgColor?.hex, borderColor: uiConfig?.button?.btnBgColor?.hex}}onClick={() => setPropType('button')}>Button</button>
                <button 
                    className={`text-sm rounded-full py-2 px-8 border border-customOne ${propType === 'table' ? 'bg-customOne text-white ' : 'text-customOne'}`}  
                    style={propType === 'table' ? {backgroundColor: uiConfig?.button?.btnBgColor?.hex, borderColor: uiConfig?.button?.btnBgColor?.hex} : {color: uiConfig?.button?.btnBgColor?.hex, borderColor: uiConfig?.button?.btnBgColor?.hex}}
                    onClick={() => setPropType('table')}>Table</button>
            </div>
            <div className="flex px-4 py-4 ">
                <div className="px-8 py-4 basis-1/4 ">
                    {/* <div className="text-center py-2 text-gray-700 text-xl">Customization Options</div> */}
                    {
                        propType === 'colour' &&
                        <div className="flex flex-col justify-between gap-1">
                            <div className="flex-1">
                                <label className={subTitle}>Primary Colour</label>
                                <div className="">
                                    <div className="">
                                        <ColorPicker color={primaryColor} onChange={setPrimaryColor} height={50}/>
                                    </div>
                                </div>
                            </div>
                            <div className="flex-1">
                                <label className={subTitle}>Secondary Colour</label>
                                <div className="">
                                    <div className="">
                                        <ColorPicker color={secondaryColor} onChange={setSecondaryColor} height={50}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {
                        propType === 'font' &&
                        <div className="flex flex-col justify-between gap-2 mt-2">
                            <div className="">
                                <label className={subTitle}>Font Family</label>
                                <select
                                    name="fontFamily"
                                    value={fontData.fontFamily}
                                    className={inputStyle}
                                    onChange={e => updateFormData(e, fontData, setFontData)}
                                >
                                    <option>---Select Font Family---</option>


                                    {
                                        fontFamily.map((font, ind) => <option value={font} key={ind}>{font}</option>)
                                    }
                                </select>
                            </div>
                            <div className="">
                                <label className={subTitle}>Font Size</label>
                                <select
                                    name="fontSize"
                                    value={fontData.fontSize}
                                    className={inputStyle}
                                    onChange={e => updateFormData(e, fontData, setFontData)}
                                >
                                    <option>---Select Font Size---</option>
                                    {
                                        fontSize.map((size, ind) => <option key={ind} value={size}>{size}</option>)
                                    }
                                </select>
                            </div>
                        </div>
                    }

                    {
                        propType === 'logo' &&
                        <div className="flex flex-col gap-2 mt-2"> 
                            <div className="">
                                <div className={subTitle}>Company Logo</div>
                                <div className="py-2">
                                    {
                                        logoUrl?.landingLogo ? 
                                        <div className="flex gap-1">
                                            <img src={logoUrl?.landingLogo}  width={100}  />
                                            <span className="font-semibold text-lg cursor-pointer" onClick={() => cancelImage('landingLogo', 'logo')}>x</span>
                                        </div>
                                        :
                                        <div className="text-sm text-center p-2 border border-gray-300 w-full"><label htmlFor="landing-logo">Select Logo</label></div>
                                    }
                                </div>
                                <input id='landing-logo' type="file" name="landingLogo" className="hidden" onChange={updateLogoData} />
                            </div>
                        </div>
                    }
                    

                    {
                        propType === 'button'  &&
                        <div className="flex flex-col justify-between gap-2">
                            <div className="flex flex-col gap-1">
                                <div className="flex-1">
                                    <label className={subTitle}>Background Colour</label>
                                    <div className="">
                                        <div className="">
                                            <ColorPicker color={btnBgColor} onChange={setBtnBgColor} height={50}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-1">
                                    <label className={subTitle}>Font Colour</label>
                                    <div className="">
                                        <div className="">
                                            <ColorPicker color={btnFontColor} onChange={setBtnFontColor} height={50}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="flex-1 flex">
                                <label className="text-lg w-2/3 ">Font Family</label>
                                <select
                                    name="fontFamily"
                                    value={buttonData.fontFamily}
                                    className="h-8 w-full outline-none border border-gray-400 rounded-lg px-2 " 
                                    onChange={e => updateFormData(e, buttonData, setButtonData)}
                                >
                                    <option>---Select Font Family---</option>
                                    {
                                        fontFamily.map((font, ind) => <option value={font} key={ind}>{font}</option>)
                                    }
                                </select>
                            </div> */}
                            {/* <div className="flex-1 flex justify-between">
                                <label className="flex text-lg w-2/3 ">Font Size</label>
                                <select
                                    name="fontSize"
                                    value={buttonData.fontSize}
                                    className="h-8 w-full outline-none border border-gray-400 rounded-lg px-2 " 
                                    onChange={e => updateFormData(e, buttonData, setButtonData)}
                                >
                                    <option value={false}>---Select Font Size---</option>s  
                                    {
                                        fontSize.map((size, ind) => <option key={ind} value={size}>{size}</option>)
                                    }
                                </select>
                            </div> */}
                        </div>
                    }

                    {/* {
                        propType === 'icon' &&
                        <div className="flex flex-col gap-2 mt-2"> 
                            <div className="">
                                <div className={subTitle}>Technician Icon</div>
                                <div className="text-right py-2">
                                    {
                                        iconUrl.technicianIcon ?
                                        <div className="flex gap-1">
                                            <img src={iconUrl.technicianIcon}  width={100} />
                                            <span className="font-semibold text-lg cursor-pointer" onClick={() => cancelImage('technicianIcon', 'icon')}>x</span>
                                        </div>
                                        :
                                        <div className="text-sm text-center p-2 border border-gray-300 w-full"><label htmlFor="technician-icon">Select Icon</label></div>
                                    }
                                </div>
                                <input id='technician-icon' type="file" name='technicianIcon' onChange={updateIconData} className="hidden" />
                            </div>
                            <div className="">
                                <div className={subTitle}>Manager Icon</div>
                                <div className="text-right py-2">
                                    {
                                        iconUrl.managerIcon ?
                                        <div className="flex gap-1">
                                            <img src={iconUrl.managerIcon}  width={100}  />
                                            <span className="font-semibold text-lg cursor-pointer" onClick={() => cancelImage('managerIcon', 'icon')}>x</span>
                                        </div>
                                        :
                                        <div className="text-sm text-center p-2 border border-gray-300 w-full"><label htmlFor="manager-icon">Select Icon</label></div>
                                    }
                                </div>
                                <input id='manager-icon' type="file" name="managerIcon" onChange={updateIconData} className="hidden" />
                            </div>
                        </div>
                    } */}

                    {
                        propType === 'table' &&
                        <div className="flex flex-col justify-between gap-1">
                            <div className="flex-1">
                                <label className={subTitle}>Header Colour</label>
                                <div className="">
                                    <div className="">
                                        <ColorPicker color={headerColor} onChange={setHeaderColor} height={50}/>
                                    </div>
                                </div>
                            </div>
                            <div className="flex-1">
                                <label className={subTitle}>Font Colour</label>
                                <div className="">
                                    <div className="">
                                        <ColorPicker color={tableFontColour} onChange={setTableFontColor} height={50}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                <div className="basis-3/4">
                    <div className={subTitle}>Preview</div>
                    <div className="px-2">
                        <UIPreview 
                            color={{primaryColor, secondaryColor}} 
                            font={fontData} 
                            iconUrl={iconUrl} 
                            logoUrl={logoUrl} 
                            button={{...buttonData, btnBgColor, btnFontColor}} 
                            table={{headerColor, fontColor: tableFontColour}} 
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Customize;